module.exports = __webpack_public_path__ + "img/Belgium.adb770a7.png";